//
// FilterDescription.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";
import "./FilterDescriptionSource";
import "../dataDefinition/DataDefinitionFilterInfo";
import "../dataDefinition/DataItemInfo";

var FilterDescription = createModule("BIRD::FilterDescription", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getPrettyDescription: [7],
        getTitle: [7],
        asDataItemInfos: [[1]],
        getSourceType: [4],
        asDataDefinitionFilterInfo: [[1]],
        getDescription: [7],
    },
    {
        getDescriptions: [[7],[1],4,2],
        getPrettyDescriptions: [[7],[1],2],
    },
    ,
]);
export default FilterDescription;
